module.exports = __webpack_public_path__ + "img/green.1405a089.png";